import { ChevronRightLight } from "@certa/icons/components/ChevronRightLight";

import {
  TypographyColors,
  Typography,
  TypographyVariants
} from "@certa/catalyst/components/Typography";

import { Stack } from "@certa/catalyst/layouts/Stack";
import { toCapital } from "@certa/common/utils/string";

import { useObjectTypeTranslationsManager } from "@certa/common/store/dataObjects/useObjectTypeTranslationsManager";

import type { InitializerObjectHierarchy } from "./StartWorkflowFromObjectDialog.types";

type ObjectTypeHierarchyStepperProps = {
  objectTypesHierarchy: InitializerObjectHierarchy[];
  selectedObjectTypeTag: InitializerObjectHierarchy;
};

export const ObjectTypeHierarchyStepper = (
  props: ObjectTypeHierarchyStepperProps
) => {
  const { objectTypesHierarchy, selectedObjectTypeTag } = props;

  const { getTranslatedUISchema, getObjectTypeByTag } =
    useObjectTypeTranslationsManager();

  if (objectTypesHierarchy.length === 1) {
    return null;
  }

  return (
    <Stack direction="horizontal" gap="16" align="center">
      {objectTypesHierarchy.map((objectType, index) => {
        const objectTypeTag = objectType.tag;

        const isObjectTypeSelected =
          selectedObjectTypeTag.tag === objectTypeTag;

        const objectTypeTranslatedUISchema =
          getTranslatedUISchema(objectTypeTag);

        const objectTypeUiSchema = getObjectTypeByTag(objectTypeTag)?.uiSchema;

        const objectTypeLabel =
          objectTypeTranslatedUISchema?.display_names?.singular ||
          objectTypeUiSchema?.display_names?.singular ||
          toCapital(objectTypeTag || "");

        return (
          <Stack
            key={objectType.tag}
            direction="horizontal"
            gap="16"
            align="center"
            height="2rem"
          >
            <Stack gap="4">
              <Typography
                variant={TypographyVariants.LABEL_SM}
                color={
                  isObjectTypeSelected
                    ? TypographyColors.NEUTRAL_800
                    : TypographyColors.NEUTRAL_600
                }
              >
                {objectTypeLabel}
              </Typography>
            </Stack>
            {index !== objectTypesHierarchy.length - 1 && (
              <Stack>
                <ChevronRightLight />
              </Stack>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};
